export type OperationsBillingStrictness = 'simple' | 'standard' | 'strict';

export const DEFAULT_OPERATIONS_BILLING_STRICTNESS: OperationsBillingStrictness = 'standard';

const VALID_STRICTNESS_VALUES = new Set<OperationsBillingStrictness>(['simple', 'standard', 'strict']);

function toStrictness(value: unknown): OperationsBillingStrictness | null {
  if (typeof value !== 'string') {
    return null;
  }
  const normalized = value.trim().toLowerCase();
  return VALID_STRICTNESS_VALUES.has(normalized as OperationsBillingStrictness)
    ? (normalized as OperationsBillingStrictness)
    : null;
}

function getCustomSettingsRecord(customSettings: unknown): Record<string, unknown> | null {
  if (!customSettings || typeof customSettings !== 'object' || Array.isArray(customSettings)) {
    return null;
  }
  return customSettings as Record<string, unknown>;
}

export function resolveOperationsBillingStrictness(customSettings: unknown): OperationsBillingStrictness {
  const record = getCustomSettingsRecord(customSettings);
  if (!record) {
    return DEFAULT_OPERATIONS_BILLING_STRICTNESS;
  }

  return toStrictness(record.operations_billing_strictness)
    || toStrictness(record.billing_strictness)
    || DEFAULT_OPERATIONS_BILLING_STRICTNESS;
}

export function normalizeOperationsBillingStrictness(value: unknown): OperationsBillingStrictness {
  return toStrictness(value) || DEFAULT_OPERATIONS_BILLING_STRICTNESS;
}

export function isSimpleBilling(strictness: OperationsBillingStrictness): boolean {
  return strictness === 'simple';
}

export function requiresBillingReview(strictness: OperationsBillingStrictness): boolean {
  return strictness === 'standard' || strictness === 'strict';
}

export function requiresBillingApproval(strictness: OperationsBillingStrictness): boolean {
  return strictness === 'strict';
}
